import moment, { Moment } from 'moment';
import { defineComponent, PropType } from 'vue';
import { NTooltip } from 'naive-ui';

import ComponentBase from '~/components/component-base';

import { Measure } from '~/api/models/measure.model';

import { Timeslot } from './timeslot.model';
import { dangerColor, successColor } from '~/variables';
import { AvoltaAlarmEnum } from '~/configs/alarms/avolta-alarm.model';
import { AvoltaAlarmConfiguration } from '~/configs/alarms/avolta-alarm.config';

export default defineComponent({

    extends: ComponentBase,

    components: {
        NTooltip,
    },

    props: {
        measures: { type: Array as PropType<Measure[]>, required: true},
        since: { type: Object as PropType<Moment>, required: true},
        before: { type: Object as PropType<Moment>, required: true},
    },

    data() {
        return {
            width: 0,
            ready: false,
        }
    },

    mounted() {
        const element = this.$refs?.container as HTMLDivElement;

        if(!element) {
            this.ready = false;
        }

        this.width = element?.getBoundingClientRect()?.width || 0;

        this.ready = true;
    },

    computed: {
        timeslots(): Timeslot[] {

            if(!this.since || !this.before) {
                return [];
            }

            let current: Moment = this.before.clone();
            let result: Timeslot[] = [];
            let i = 0;

            while(current.isAfter(this.since)) {
                const start: Moment = current.clone().subtract(1, 'days');
                const end: Moment = current.clone();
                result.push({
                    start,
                    id: i,
                    end,
                    battery: false,
                    gas: false,
                    offline: false,
                    system_failure: false,
                    eol: false,
                });
                current = start;
                i++;
            }

            result = result.reverse();

            if(!this.measures?.length) {
                return result;
            }

            result.forEach(ts => {
                const measures = this.measures.filter(m => moment.unix(m.date).isBetween(ts.start, ts.end));

                measures.forEach(m => {
                    ts.gas = ts.gas || !!m?.values?.CH4_concentration_alarm;
                });


            });


            return result;
        },

        slotWidth(): string {

            if(!this.timeslots?.length) {
                return '0';
            }

            const slotWidth = this.timeslots?.length > 0 ? this.width / this.timeslots?.length : 20;
            return `${slotWidth}px`;
        }
    },

    methods: {
        getColor(timeslot: Timeslot): string {
            if(timeslot?.gas) {
                return dangerColor;
            } else if(timeslot?.battery) {
                return AvoltaAlarmConfiguration[AvoltaAlarmEnum.CH4_battery_alarm]?.color;
            }  else if(timeslot?.system_failure) {
                return AvoltaAlarmConfiguration[AvoltaAlarmEnum.CH4_system_failure]?.color;
            } else if(timeslot?.offline) {
                return AvoltaAlarmConfiguration[AvoltaAlarmEnum.offline]?.color;
            } else {
                return successColor;
            }
        }
    }
});